var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManageUsersCreateUser',{attrs:{"MU":_vm.MU,"accessRoles":_vm.accessRoles,"userGroups":_vm.userGroups},on:{"changeRole":_vm.changeRole,"save":function($event){return _vm.save({edit: false})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }